module.exports = __webpack_public_path__ + "img/typewriter.8e29da55.png";